import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  mainContainer: {
    height: "100%",
  },
  container: {
    alignItems: "center",
    //flex: 1,
    justifyContent: "center",
    marginTop: "80px",
    marginBottom: "2rem",
  },
  msgUnderImg: {
    marginTop: "28px",
    marginBottom: "28px",
    alignItems: "center",
    textAlign: "center",
  },
  textContainer: {
    paddingBottom: 10,
  },
});

export default styles;
